import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getSwitchTarget, isEnglishPath } from '../data/i18nMap';

// Simple FR | EN text switcher (no flags). French is the default/primary language.
const LanguageSwitcher = ({ className = '' }) => {
  const { pathname } = useLocation();
  const en = isEnglishPath(pathname);
  const target = getSwitchTarget(pathname);

  return (
    <div className={`flex items-center gap-1.5 text-sm font-medium ${className}`} data-testid="language-switcher">
      {en ? (
        <Link to={target} hrefLang="fr" className="opacity-80 hover:opacity-100 transition-opacity" data-testid="lang-switch-fr">FR</Link>
      ) : (
        <span className="font-bold" aria-current="true" data-testid="lang-current-fr">FR</span>
      )}
      <span className="opacity-40">|</span>
      {en ? (
        <span className="font-bold" aria-current="true" data-testid="lang-current-en">EN</span>
      ) : (
        <Link to={target} hrefLang="en" className="opacity-80 hover:opacity-100 transition-opacity" data-testid="lang-switch-en">EN</Link>
      )}
    </div>
  );
};

export default LanguageSwitcher;
